import { Elm } from "./Main.elm"
import * as serviceWorker from "./serviceWorker"
import "../public/paddle.js"

export function main(loadPlayground) {
  let features = []

  try {
    features = JSON.parse(
      process.env.ELM_APP_AIRSEQUEL_FEATURES ||
        localStorage.getItem("features") ||
        "[]",
    )
  } catch (error) {
    console.warn(error)
  }

  const app = Elm.Main.init({
    node: document.getElementById("root"),
    flags: {
      edition: process.env.ELM_APP_AIRSEQUEL_EDITION,
      features,
      sessionToken: localStorage.sessionToken || null,
      username: localStorage.username || null,
    },
  })

  app?.ports?.saveToLocalStorage?.subscribe(({ key, value }) => {
    if (typeof value !== "string") {
      value = JSON.stringify(value)
    }
    localStorage.setItem(key, value)
  })

  app?.ports?.removeFromLocalStorage?.subscribe((key) => {
    localStorage.removeItem(key)
  })

  app?.ports?.loadPlayground?.subscribe(loadPlayground)

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister()
}
